import React from "react";
import "./ProgressBar.css";

/**
 * Barre d'avancement d'une indexation par lots.
 *
 * Elle n'estime rien : chaque lot envoyé répond le nombre de segments
 * réellement écrits, et c'est ce nombre qui avance. Le composant précédent
 * interrogeait un état côté serveur en boucle, ce qui ajoutait un identifiant
 * de corrélation, un stockage partagé et un point de panne — pour finir par
 * afficher « suivi indisponible » quand l'une de ces pièces manquait.
 */
export default function ProgressBar({ written, failed, total, state, message, onAbort, unit = "segment" }) {
    if (!total) {
        return null;
    }

    const percent = Math.min(100, Math.round(((written + failed) / total) * 100));

    return (
        <div className={`pbar pbar--${state}`}>
            <div className="pbar__head">
                <strong>
                    {state === "running" && "Indexation en cours"}
                    {state === "done" && "Indexation terminée"}
                    {state === "error" && "Indexation interrompue"}
                </strong>
                <span className="pbar__counter">
                    {written}/{total} {unit}(s)
                    {failed > 0 && <> · {failed} en échec</>}
                </span>
            </div>

            <div className="pbar__track" role="progressbar"
                 aria-valuemin={0} aria-valuemax={100} aria-valuenow={percent}
                 aria-label="Avancement de l'indexation">
                <div className="pbar__fill" style={{ width: `${percent}%` }} />
            </div>

            {state === "running" && (
                <div className="pbar__foot">
                    {/* L'avertissement doit être là PENDANT, pas après : une fois la
                        page rechargée il est trop tard pour prévenir. */}
                    <span className="pbar__warn">
                        Ne rechargez pas la page et ne fermez pas cet onglet : l'indexation
                        s'arrêterait en cours de route.
                    </span>
                    {onAbort && (
                        <button type="button" className="pbar__abort" onClick={onAbort}>
                            Interrompre
                        </button>
                    )}
                </div>
            )}

            {message && state !== "running" && <p className="pbar__message">{message}</p>}
        </div>
    );
}
